/*
 * tp-sticky-kaufleiste.js
 * ------------------------------------------------------------
 * Feste Kaufleiste am unteren Rand der Produktseite (Markup: snippets/tp-product-sticky-kaufleiste.liquid).
 * Sie erscheint, sobald der echte Kaufknopf ([data-tp-cart-btn]) oben aus dem Bild gescrollt ist, und
 * verschwindet wieder, wenn er zurück im Bild ist. Auf breiten Bildschirmen blendet das CSS sie ohnehin aus.
 *
 * Die Leiste kauft nicht selbst: ihr Knopf klickt den echten Kaufknopf. Variante, Menge, Warenkorb-Aufruf
 * und Drawer bleiben dadurch an einer Stelle. Preis ([data-tp-price]) und Knopftext (Hinzufügen/Ausverkauft/
 * „Wird hinzugefügt…“) werden gespiegelt, auch wenn sie sich nach einem Variantenwechsel ändern.
 */
(function () {
  var bar = document.querySelector('[data-tp-sticky-buy]');
  var realBtn = document.querySelector('[data-tp-cart-btn]');
  if (!bar || !realBtn) return;

  var priceEl = document.querySelector('[data-tp-price]');
  var barPrice = bar.querySelector('[data-tp-sticky-price]');
  var barBtn = bar.querySelector('[data-tp-sticky-btn]');
  var realText = realBtn.querySelector('[data-tp-cart-btn-text]') || realBtn;

  // Die Leiste liegt am Seitenende (body), damit kein transformierter Elternknoten position:fixed verschiebt.
  document.body.appendChild(bar);

  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }

  function sync() {
    barBtn.textContent = clean(realText.textContent);
    barBtn.disabled = !!realBtn.disabled;
    if (priceEl) barPrice.textContent = clean(priceEl.textContent);
  }

  var shown = false;
  function update() {
    // „Vorbei gescrollt“: der Kaufknopf liegt komplett oberhalb des sichtbaren Bereichs.
    var gone = realBtn.getBoundingClientRect().bottom < 0;
    if (gone === shown) return;
    shown = gone;
    if (gone) sync();
    bar.hidden = !gone;
    document.documentElement.classList.toggle('tp-sticky-buy-aktiv', gone);
  }

  barBtn.addEventListener('click', function () { if (!realBtn.disabled) realBtn.click(); });

  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { if (shown) sync(); });
    mo.observe(realBtn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    if (priceEl) mo.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; update(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
